import React from "react";
import '../assets/styles/Footer.scss';

function Footer() {
  return (
    <footer>
      <p>© {new Date().getFullYear()} João Farias Pinto</p>
    </footer>
  );
}

export default Footer;